const channelConfiguration = () => import('./channelConfiguration');
const splashScreenManage = () => import('./splashScreenManage');
// const internalMessageConfiguration = () => import('./internalMessageConfiguration');
// const promotionPositionConfiguration = () => import('./promotionPositionConfiguration');
// const searchForConfiguration = () => import('./searchForConfiguration');
// const popupConfiguration = () => import('./popupConfiguration');
// const customerFeedackConfiguration = () => import('./customerFeedackConfiguration');


const Router = [
  {
    path: 'channelConfiguration',
    name: 'channelConfiguration',
    component: channelConfiguration,
    meta: {
      title: 'Banner配置'
    }
  },
  {
    path: 'splashScreenManage',
    name: 'splashScreenManage',
    component: splashScreenManage,
    meta: {
      title: '闪屏配置'
    }
  },
  // {
  //   path: 'internalMessageConfiguration',
  //   name: 'internalMessageConfiguration',
  //   component: internalMessageConfiguration,
  //   meta: {
  //     title: '站内信配置'
  //   }
  // },
  // {
  //   path: 'promotionPositionConfiguration',
  //   name: 'promotionPositionConfiguration',
  //   component: promotionPositionConfiguration,
  //   meta: {
  //     title: '推广位配置'
  //   }
  // },
  // {
  //   path: 'searchForConfiguration',
  //   name: 'searchForConfiguration',
  //   component: searchForConfiguration,
  //   meta: {
  //     title: '搜索配置'
  //   }
  // },
  // {
  //   path: 'popupConfiguration',
  //   name: 'popupConfiguration',
  //   component: popupConfiguration,
  //   meta: {
  //     title: '弹窗管理'
  //   }
  // },
  // {
  //   path: 'customerFeedackConfiguration',
  //   name: 'customerFeedackConfiguration',
  //   component: customerFeedackConfiguration,
  //   meta: {
  //     title: '客服反馈配置'
  //   }
  // }
];
export default Router;